import { parseJSON } from 'src/utils/json';
/**
 * Thin JSON wrapper over an existing MMKV instance.
 * Must share the same instance as `getNativeStorage` so web listeners
 * (per-instance on react-native-mmkv) fire for imperative writes.
 */
export default function createJSONStorage(storage) {
    return {
        set(key, value) {
            storage.set(key, JSON.stringify(value));
        },
        get(key) {
            const value = storage.getString(key);
            return typeof value === 'string' ? parseJSON(value) : value;
        },
        delete(key) {
            return storage.remove(key);
        },
        clearAll() {
            storage.clearAll();
        },
        contains(key) {
            return storage.contains(key);
        },
        getAllKeys() {
            return storage.getAllKeys();
        },
        addOnValueChangedListener(onValueChanged) {
            return storage.addOnValueChangedListener(onValueChanged);
        },
    };
}
